import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import MenuOverlay from './components/MenuOverlay';
import HeroSection from './components/HeroSection';
import QuoteSection from './components/QuoteSection';
import ImageCollage from './components/ImageCollage';
import GalleryPage from './components/GalleryPage';

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState('home');

  // Initialize page based on URL
  useEffect(() => {
    const path = window.location.pathname;
    const page = path === '/' ? 'home' : path.substring(1);
    setCurrentPage(page);
  }, []);

  // Handle browser back/forward buttons
  useEffect(() => {
    const handlePopState = () => {
      const path = window.location.pathname;
      const page = path === '/' ? 'home' : path.substring(1);
      setCurrentPage(page);
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  // Update page title based on current page
  useEffect(() => {
    const pageTitles = {
      'home': 'Raghav Khanna - Photographer-Director',
      'nature': 'Nature - Raghav Khanna',
      'baby-shoot': 'Baby Shoot - Raghav Khanna',
      'wedding': 'Wedding - Raghav Khanna',
      'birthday': 'Birthday - Raghav Khanna',
    };
    document.title = pageTitles[currentPage] || 'Raghav Khanna';
  }, [currentPage]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const navigateTo = (page) => {
    setCurrentPage(page);
    const url = page === 'home' ? '/' : `/${page}`;
    window.history.pushState({}, '', url);
    closeMenu();
  };

  const renderPage = () => {
    switch(currentPage) {
      case 'home':
        return (
          <>
            <HeroSection />
            <QuoteSection />
            <ImageCollage />
          </>
        );
      case 'nature':
        return <GalleryPage title="NATURE" />;
      case 'baby-shoot':
        return <GalleryPage title="BABY SHOOT" />;
      case 'wedding':
        return <GalleryPage title="WEDDING" />;
      case 'birthday':
        return <GalleryPage title="BIRTHDAY" />;
      default:
        return (
          <>
            <HeroSection />
            <QuoteSection />
            <ImageCollage />
          </>
        );
    }
  };

  return (
    <div className="App">
      <Header onMenuToggle={toggleMenu} isMenuOpen={isMenuOpen} />
      <MenuOverlay isOpen={isMenuOpen} onClose={closeMenu} onNavigate={navigateTo} />
      {renderPage()}
    </div>
  );
}

export default App;

